import { DailyAudio, DailyVideo, useDaily, useLocalParticipant } from '@daily-co/daily-react'
import { Box, Button } from '@mui/material'
import { LogOut, SquareUserRound } from 'lucide-react'
import { useContext } from 'react'
import { VisioContext } from '../utils/context/visio.context'

const VideoCall = ({ leaveCall, cameraOn }: { leaveCall: () => void; cameraOn: boolean }) => {
  const daily = useDaily()
  const localParticipant = useLocalParticipant()
  const { isCallInProgress } = useContext(VisioContext)

  return (
    <div>
      {isCallInProgress && localParticipant && (
        <>
          {cameraOn ? (
            <DailyVideo
              sessionId={localParticipant.session_id}
              type="video"
              automirror
              fit="contain"
              style={{ height: '500px', width: '500px' }}
            />
          ) : (
            <SquareUserRound style={{ fontSize: '500px' }} />
          )}

          <DailyAudio />
          <Box
            sx={{
              display: 'flex',
              gap: 2,
              justifyContent: 'center',
              mt: 2,
            }}
          >
            <Button
              onClick={() => {
                daily?.leave()
                daily?.destroy()
                leaveCall()
              }}
              variant="contained"
              sx={{
                '&:disabled': { backgroundColor: 'red', opacity: '30%' },
                '&:hover': { backgroundColor: 'darkred' },
                backgroundColor: 'red',
              }}
            >
              <LogOut />
              Quitter
            </Button>
          </Box>
        </>
      )}
    </div>
  )
}

export default VideoCall
